/* eslint-disable react/prop-types */
import React, { Component } from "react";
// import PropTypes from "prop-types";
import { Row, Col, Tabs, Button, message } from "antd";
import { List } from "immutable";
import { connect } from "react-redux";
import "styles/cibil-page.css";
import { CompanyService } from "../services";
import {
    ADHOC_CASES_COLS_PRE_APPROVED,
    ADHOC_CASES_COLS_REST,
} from "constants/table-columns";
import { history } from "router";
import { bindActionCreators } from "redux";
import AdhocTable  from "../modules/ad-hoc-table";

const { TabPane } = Tabs;

const TabsEnums = {
    "preApproved" : {
        ordering : null,
        dataFilter : null
    },
    "requested" : {
        ordering : 2,
        dataFilter : null
    },
    "myCases" : {
        ordering : 2,
        dataFilter : "my-cases"
    },
    "referredBack" : {
        ordering : 1,
        dataFilter : "referred-back"
    },
    "sentApproval" : {
        ordering : "3,4",
        dataFilter : "sent-for-approval"
    },
    "rejected" : {
        ordering : 2,
        dataFilter : "rejected"
    },
    "approved" : {
        ordering : 5,
        dataFilter : ""
    }
};

const tabCountKeys = {
    "preApproved":"pre_approved_adhoc",
    "requested": "all_cases",
    "myCases": "my_cases",
    "referredBack": "referred_cases",
    "sentApproval": "sent_for_approval",
    "rejected": "referred_cases_fi",
    "approved": "approved"
};

let columns_rest_tab = ADHOC_CASES_COLS_REST;
class AdhocCases extends Component {
  state = {
      adhocLimitColData: List(),
      openAssignModal: false,
      page: 1,
      pageSize: 10,
      loading: false,
      tabCount: {},
      selectedTab: "preApproved",
      usersList: [],
      remarksAssignCase: [],
      selectedRows: List(),
      redirectBack: false,
      expandedRowKeys: [],
      adhocPara: {
          creditApprovedLimit: null,
          caseLimitType: null,
          caseLimitFacility: null,
          adhocLimitVal: null,
          comments: "",
          case_id: null
      },
      searchParam:""
  };
  
  componentDidMount() {
      CompanyService.getAdhocCases(this.state.page, this.state.pageSize, "")
          .then((res) => {
              if (
                  res.status === 200 &&
          res.data &&
          res.data.results &&
          Array.isArray(res.data.results)
              ) {
                  this.setState({ adhocLimitColData: new List(res.data.results) });
                  this.setState({ loading: false });
              }
          })
          .catch(() => {
              this.setState({ loading: false });
              message.error("Something went wrong");
          });
      CompanyService.getUsersList("ADHOC").then((res) => {
          this.setState({usersList:res.data});
      }).catch(() =>{
          message.error("Something went wrong");
      });
      CompanyService.getAdhocCasesCount().then((res) => {
          this.setState({tabCount: res.data});
      }).catch(() =>{
          message.error("Something went wrong");
      });
  }
  
  componentDidUpdate() {
      if (this.props.permissions.size && !this.state.redirectBack) {
          if (!this.props.permissions.get("page_adhoc_edit") && !this.props.permissions.get("page_adhoc_bulk_assign")) {
              this.setState({
                  redirectBack: true
              }, () => {
                  this.props.history.goBack();
              });
          }
      }
  }

  openAssignCaseModal = (value) => {
      this.setState({ selectedRows: value ,openAssignModal: true});
  };
  
  callAdhocListApi = (searchParam=this.state.searchParam,activeIndex= this.state.selectedTab, page=this.state.page, page_size=this.state.pageSize) =>{
      this.setState({ loading: true });
      if (activeIndex != "preApproved") {
          CompanyService.getAdhocCasesList(searchParam, TabsEnums[activeIndex]?.ordering, page, page_size,TabsEnums[activeIndex]?.dataFilter)
              .then((res) => {
                  if (res.status === 200 && res.data && Array.isArray(res.data.results)) {
                      this.setState({ adhocLimitColData: new List(res.data.results), loading: false, page: page, pageSize: page_size });
                  }
              })
              .catch(() => {
                  this.setState({ loading: false});
                  message.error("Something went wrong");
              });
      } else {
          CompanyService.getAdhocCases(page, page_size, searchParam)
              .then((res) => {
                  if (res.status === 200 && res.data && res.data.results && Array.isArray(res.data.results)) {
                      this.setState({ adhocLimitColData: new List(res.data.results), loading: false, page: page, pageSize: page_size });
                  }
              })
              .catch(() => {
                  this.setState({ loading: false });
                  message.error("Something went wrong");
              });
      }
  }

  onChangeTab = (activeIndex) => {
      this.setState({ loading: true , adhocLimitColData : List(), selectedTab: activeIndex, page: 1, pageSize: 10 });
      columns_rest_tab = ADHOC_CASES_COLS_REST;
      if(activeIndex == "rejected"){
          const keysToDelete = ["adhoc_requested_credit", "this_user", "current_user"];
          columns_rest_tab = columns_rest_tab.deleteAll(keysToDelete);
      }else{
          columns_rest_tab = ADHOC_CASES_COLS_REST;
      }
      this.callAdhocListApi("",activeIndex, 1, 10);
  };

  
  selectLimitType = (val) => {
      this.setState((prevState) => {
          return { adhocPara: { ...prevState.adhocPara, caseLimitType: val } };
      });
  };

  getPageSize = (page, pageSize) => {
      this.setState({ page: this.state.page });
      this.setState({ pageSize: this.state.pageSize });
  };
  onFilter = (val) => {
      const searchParam =
      (val && val.search && val?.search[0] && val.search[0].trim()) || "";
      this.setState({searchParam});
      this.callAdhocListApi(searchParam);
  };
  
  updateTable = () => {
      this.setState({ loading: true });
      const activeIndex = this.state.selectedTab;
      const data_filter = TabsEnums[activeIndex].dataFilter;
      if (activeIndex != "preApproved") {
          CompanyService.getAdhocCasesList(
              "",
              TabsEnums[activeIndex].ordering,
              this.state.page,
              this.state.pageSize,
              data_filter
          )
              .then((res) => {
                  if (
                      res.status === 200 &&
          res.data &&
          Array.isArray(res.data.results)
                  ) {
                      this.setState({ adhocLimitColData: new List(res.data.results) });
                      this.setState({ loading: false });
                  }
              })
              .catch(() => {
                  this.setState({ loading: false });
                  message.error("Something went wrong");
              });
      } else {
          CompanyService.getAdhocCases(this.state.page, this.state.pageSize, "")
              .then((res) => {
                  if (
                      res.status === 200 &&
          res.data &&
          res.data.results &&
          Array.isArray(res.data.results)
                  ) {
                      this.setState({ adhocLimitColData: new List(res.data.results) });
                      this.setState({ loading: false });
                  }
              })
              .catch(() => {
                  this.setState({ loading: false });
                  message.error("Something went wrong");
              });
      }
  }

  updateState = (val, stateBool, case_id) =>{
      if(stateBool){
          this.setState({adhocPara:{}});
      }else{
          this.setState({
              adhocPara: {
                  ...this.state.adhocPara,
                  ...val,
                  case_id
              },
          });
      }
      if(val.adhocLimitVal >60|| val.adhocLimitVal <0){
          message.error("Adhoc Limit Validity should not exceed 60 days as per policy");
      }
     
  }
  adHocRequestedTable = () => {
      return (
          <AdhocTable
              loading={this.state.loading}
              updateTable = {this.updateTable}
              usersList={this.state.usersList}
              userId={this.props.userDetails.id}
              showAssign={(this.state.selectedTab == "requested")}
              showOpen={this.state.selectedTab == "rejected"}
              columns={columns_rest_tab}
              data={this.state.adhocLimitColData || List()}
              adhocPara={this.state.adhocPara}
              selectLimitType={this.selectLimitType}
              selectedTab={this.state.selectedTab}
              updateState={this.updateState}
              onFilter={this.onFilter}
              callAdhocListApi={this.callAdhocListApi}
              tabCount={this.state.tabCount && this.state.tabCount[tabCountKeys[this.state.selectedTab]]}
              userDetails={this.props.userDetails}
              permissions={this.props.permissions}
              page={this.state.page}
              pageSize={this.state.pageSize}
          />
      );
  };
 
  render() {
      return (
          <Row>
              <Col span={24} className={"d-flex justify-content-flex-end mt-10"}>
                  {this.state.selectedTab == "preApproved" && (
                      <Button
                          type={"primary"} className="mr-10"
                          onClick={() => history.replace({ pathname: "/app/bulk-upload" })}
                      >
              Bulk Request
                      </Button>
                  )}
              </Col>
             
              <Col span={24} className={"p-5"}>
                  <Tabs className="tabsDesign" defaultActiveKey="preApproved" onChange={(key) => this.onChangeTab(key)}>
                      <TabPane tab="Pre-Approved Cases" key="preApproved">
                          <AdhocTable
                              loading={this.state.loading}
                              columns={ADHOC_CASES_COLS_PRE_APPROVED}
                              data={this.state.adhocLimitColData}
                              adhocPara={this.state.adhocPara}
                              selectedTab={this.state.selectedTab}
                              selectLimitType={this.selectLimitType}
                              updateState={this.updateState}
                              onFilter={this.onFilter}
                              callAdhocListApi={this.callAdhocListApi}
                              tabCount={this.state.tabCount && this.state.tabCount[tabCountKeys[this.state.selectedTab]]}
                              userDetails={this.props.userDetails}
                              permissions={this.props.permissions}
                              page={this.state.page}
                              pageSize={this.state.pageSize}
                          />
                      </TabPane>
                      <TabPane tab="Requested Adhoc" key="requested">
                          {this.adHocRequestedTable()}
                      </TabPane>
                      <TabPane tab="My Cases" key="myCases">
                          {this.adHocRequestedTable()}
                      </TabPane>
                      <TabPane tab="Referred Back" key="referredBack">
                          {this.adHocRequestedTable()}
                      </TabPane>
                      <TabPane tab="Sent For Approval" key="sentApproval">
                          {this.adHocRequestedTable()}
                      </TabPane>
                      <TabPane tab="Rejected" key="rejected">
                          {this.adHocRequestedTable()}
                      </TabPane>
                      <TabPane tab="Approved" key="approved">
                          {this.adHocRequestedTable()}
                      </TabPane>
                  </Tabs>
              </Col>
          </Row>
      );
  }

  
}
const mapStateToProps = (state) => {
    return {
        userDetails: state.user.get("data"),
        permissions: state.user.get("permissions"),
        
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators({
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AdhocCases);



